// @flow
import {
    Container,
    Description,
    Device,
    Header,
    IconWrapper,
    Option,
    Seperator,
    StyledIcon,
    Summary,
    Toggle
} from './style';
import { injectIntl, intlShape } from 'react-intl';

import { getThenNotificationText } from '../common';
import ImmutablePropTypes from 'react-immutable-proptypes';
import intlMessages from '../intl';
import { NOTIFICATIONS_ON } from '~/core/constants/icons/general';
import PropTypes from 'prop-types';
import * as React from 'react';
import { ToggleButton } from '~/components/widgets';

const propTypes = {
    changeHandlers: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    options: ImmutablePropTypes.map.isRequired
};

const RecipeThenNotify = ({ changeHandlers, intl: { formatMessage }, options }) => (
    <Container>
        <Header>
            <IconWrapper>
                <StyledIcon icon={NOTIFICATIONS_ON} />
            </IconWrapper>
            <Summary>
                <Device>{getThenNotificationText(formatMessage, options)}</Device>
            </Summary>
        </Header>
        <div>
            {options.entrySeq().map(([key, value], i) => {
                return (
                    <div key={`option-${key}`}>
                        <Seperator index={i} />
                        <Option index={i}>
                            <Description>{formatMessage(intlMessages[key])}</Description>
                            <Toggle>
                                <ToggleButton isOn={value} onChange={() => changeHandlers(key)} />
                            </Toggle>
                        </Option>
                    </div>
                );
            })}
        </div>
    </Container>
);

RecipeThenNotify.propTypes = propTypes;

export default injectIntl(RecipeThenNotify);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/then-notify/index.js